import { StringHelper } from "../../../../utilities/contracts/string-helper";
import { MemberChart } from "./member-chart.model";

export class ChartLakeLoadData {
  chaseID?: number;
  masterMemberId?: string;
  measureCode?: string;
  memberSourceAliasID?: string;
  memberFirstName?: string;
  memberLastName?: string;
  memberGender?: string;
  memberDateOfBirth?: string;
  recordCount?: number;
  memberChartList?: MemberChart[];
  groupName?: string;
  chaseSourceAliasID?: string;
  reportingStatusName?: string;
  commentExists?: boolean;
  masterDocumentSourceID?: string;
  serviceProviders?: string;
  tagsText?: string;

  constructor(options: Partial<ChartLakeLoadData> = {}) {
    this.chaseID = options.chaseID;
    this.masterMemberId = StringHelper.clean(options.masterMemberId);
    this.measureCode = StringHelper.clean(options.measureCode);
    this.memberSourceAliasID = StringHelper.clean(options.memberSourceAliasID);
    this.memberFirstName = StringHelper.clean(options.memberFirstName);
    this.memberLastName = StringHelper.clean(options.memberLastName);
    this.memberGender = StringHelper.clean(options.memberGender);
    this.memberDateOfBirth = StringHelper.clean(options.memberDateOfBirth);
    this.recordCount = options.recordCount;
    this.memberChartList = (options.memberChartList || []).map(c => new MemberChart(c));
    this.groupName = StringHelper.clean(options.groupName);
    this.chaseSourceAliasID = StringHelper.clean(options.chaseSourceAliasID);
    this.reportingStatusName = StringHelper.clean(options.reportingStatusName);
    this.masterDocumentSourceID = StringHelper.clean(options.masterDocumentSourceID);
    this.tagsText = StringHelper.clean(options.tagsText);
    this.serviceProviders = StringHelper.clean(options.serviceProviders);
    this.commentExists = options.commentExists;
  }
}
